import './StatusBadge.css'

/**
 * Soft status pill. Tones mirror the Bootstrap contextual classes the legacy
 * `badge badge-light-{color}` renderer emits, so a server row that carries
 * `{status, color}` maps across unchanged.
 *
 * @param {'success'|'danger'|'warning'|'info'|'violet'|'neutral'|'accent'|'dark'|'primary'|'gold'} [tone]
 *   neutral and accent are the spec names; dark and primary their historic aliases.
 * @param {boolean} [plain]  drop the leading dot, for chips that label rather than
 *                           report state (group names, counts)
 * @param {boolean} [solid]  the tone at full strength, for the one badge on a
 *                           screen that must be unmissable. Reaching for it more
 *                           than once per view spends the emphasis.
 */
export default function StatusBadge({ tone = 'dark', plain = false, solid = false, children }) {
  const classes = [
    'status-badge',
    `status-badge--${tone}`,
    plain && 'status-badge--plain',
    solid && 'status-badge--solid',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes}>
      {!plain && <span className="status-badge__dot" aria-hidden="true" />}
      <bdi>{children}</bdi>
    </span>
  )
}
